import { IconSparkles } from "@tabler/icons-react"
import CountUp from "react-countup"
import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"

const Section4 = () => {
  return (
    <div className="s4-partner f-width m-auto">
        <p className="s4-h-text text-center"><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> Your clients could be next to recover lost revenue.</p>
        <div className="row">
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col1">
                    <p className="p1">$1 Billion+</p>
                    <p className="p2">Sales processed and reconciled automatically across delivery apps, POS, banks, and accounting software</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col2">
                    <p className="p1">1 Million+</p>
                    <p className="p2">Disputed orders detected and resolved automatically</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col3">
                    <p className="p1">$11 Million+</p>
                    <p className="p2">Revenue recovered for restaurant partners through automated dispute recovery</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col4">
                    <p className="p1"><CountUp delay={0.2} start={0} end={100} duration={6} />%</p>
                    <p className="p2">Accuracy in matching orders to settlements across multiple platforms</p>
                </motion.div>
            </div>
        </div>
    </div>
  )
}

export default Section4